import Contracts from './ContractsContainer'
export default Contracts
